//@flow
import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Toast } from 'gestalt';

type Props = {||};
type State = {||};

export default class OfflineManager extends Component<Props, State> {
  componentDidMount() {
    window.addEventListener('offline', this.handleConnectionChange);
  }

  componentWillUnmount() {
    window.removeEventListener('offline', this.handleConnectionChange);
  }

  handleConnectionChange = (event: Event) => {
    // Force re-render since no props or state changes
    this.forceUpdate();
    if (event.type === 'offline') {
      window.addEventListener('online', this.handleConnectionChange);
    } else {
      window.removeEventListener('online', this.handleConnectionChange);
    }
  };

  render() {
    const isOffline = !__SERVER__ && !navigator.onLine;

    return (
      isOffline && (
        <Box
          fit
          dangerouslySetInlineStyle={{
            __style: {
              bottom: 20,
              left: '50%',
              transform: 'translateX(-50%)',
            },
          }}
          paddingX={1}
          position="fixed"
        >
          <Toast
            color="red"
            text={i18n._(
              "Hmm...you're not connected to the internet",
              'Toast that displays when a user is offline',
            )}
          />
        </Box>
      )
    );
  }
}
